<template><div ref="chart" class="language-box"></div></template>

<script>
export default {
  name: 'LanguageCharts',
  props: { data: { type: Array, default: () => [] } },
  watch: { data: { handler: 'updateChart', deep: true } },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart)
    this.chart.setOption({
      color: ['#409eff', '#67c23a', '#e6a23c'],
      tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
      legend: { bottom: 0, left: 'center', itemWidth: 11, itemHeight: 11, textStyle: { color: '#606266', fontSize: 11 } },
      series: [{ name: '作品语言', type: 'pie', radius: ['43%', '67%'], center: ['50%', '45%'], avoidLabelOverlap: true, label: { formatter: '{b}  {d}%', color: '#606266', fontSize: 11 }, labelLine: { length: 12, length2: 10 }, itemStyle: { borderRadius: 4, borderColor: 'rgba(255,255,255,.75)', borderWidth: 2 } }]
    })
    this.updateChart()
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.chart.resize())
      this.observer.observe(this.$refs.chart)
    } else window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    else window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    resizeChart() { if (this.chart) this.chart.resize() },
    updateChart() { if (this.chart) this.chart.setOption({ series: [{ data: this.data }] }) }
  }
}
</script>

<style scoped>.language-box { width: 100%; height: 100%; min-height: 0; }</style>
